<div class="div-menu-alterno">
    <div class="div-espacio-1"></div>
    <app-retorno-estadisticas></app-retorno-estadisticas>
    <div class="div-menu-apps-alterno div-espacio-1">
        <a [ngClass]="'informacionSerie'===currentPath || 'detalle-catalogo'===currentPath ? 'seleccionado' : 'link-menu-alterno'"  (click)="irCatalogoRecomendados()">Catálogo</a> | <a
            class="link-menu-alterno" (click)="irGraficasInteractivas()">Graficador interactivo</a> | <a
            [ngClass]="'dashboard'===currentPath ? 'seleccionado' : 'link-menu-alterno'" (click)="irTablasPreconstruidas()">Tablas preconstruidas</a> | <a
            class="link-menu-alterno" (click)="irBuscadorSeries()">Descarga múltiple de datos</a>
    </div>
</div>